import axios from '@/libs/axios'

export class AlertService {


  static get URL() {
    return 'alerts'
  }


  static async getAlertById(id) {
    try {
      const response = await axios.get(`${this.URL}/${id}`)
      return response.data.alert
    }

    catch (error) {
      return error.response.data ? error.response.data.error : error.response.statusText
    }
  }


  static async createAlert(data) {
    return new Promise((resolve, reject) => {
      axios.post(`alerts`, data)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }


  static async updateAlert(id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`alerts/${id}`, data)
        .then(res => resolve(res.data.Alert))
        .catch(reason => reject(reason.response))
    })
  }



  static async deleteAlert(id) {
    return new Promise((resolve, reject) => {
      axios.delete(`${this.URL}/${id}`)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }

}
